/**
 * data-layer-directive.ts — DEPRECATED, NO-OP
 *
 * The legacy `v-track-event` / `v-track-scroll` directives that this file
 * used to register have been replaced by the single fan-out directive in
 * `tracking-lib-directive.ts`, which emits to BOTH window.nhstDataLayer
 * (legacy) and @nhst/tracking-lib (new) from one observer/listener.
 *
 * This file is kept as an empty plugin to keep file-based Nuxt plugin
 * autoloading deterministic across the branch. Delete the file in the
 * cut-over PR — there is no behavioral reason for it to exist any more.
 */
export default defineNuxtPlugin(() => {
  /*
   * Intentionally empty. See tracking-lib-directive.ts for the new directive
   * implementation.
   */
});
